import { Logger } from '@calendly/logging-service'

import { getStatsigClient } from 'services/analytics/statsig_service'

interface DecisionEventService {
  track: (flagKey: string | unknown) => void
}

export const decisionEventService: DecisionEventService = {
  track: (flagKey) => {
    if (typeof flagKey !== 'string') return

    try {
      const client = getStatsigClient()
      if (!client) return

      const gate = client.getFeatureGate?.(flagKey, { disableExposureLog: true })
      const reason = gate?.details?.reason || ''
      const isUnrecognized = reason.includes('Unrecognized') || reason === 'Uninitialized'

      if (isUnrecognized) {
        client.getDynamicConfig(flagKey)
      } else {
        client.checkGate(flagKey)
      }
    } catch {
      Logger.error({ message: '[decision_event] failed to track flag' } as any, { flagKey })
    }
  }
}
